import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { FiDownload, FiBook, FiBriefcase, FiCode } from 'react-icons/fi';
import { publicAPI } from '../services/api';
import { formatDate } from '../utils/helpers';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './Resume.css';

const Resume = () => {
  const [profile, setProfile] = useState(null);
  const [experiences, setExperiences] = useState([]);
  const [education, setEducation] = useState([]);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      publicAPI.getProfile(),
      publicAPI.getExperiences(),
      publicAPI.getEducation(),
      publicAPI.getSkills()
    ]).then(([p, exp, edu, sk]) => {
      if (p.success) setProfile(p.data);
      if (exp.success) setExperiences(exp.data);
      if (edu.success) setEducation(edu.data);
      if (sk.success) setSkills(sk.data);
    }).catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <section className="section resume-page">
      <Helmet><title>Resume | Deepak Chauhan</title></Helmet>
      <div className="container">
        <div className="resume-header">
          <div>
            <h1>Resume</h1>
            <p>{profile?.fullName} - {profile?.designation}</p>
          </div>
          {profile?.resumeUrl && (
            <a href={profile.resumeUrl} download className="btn btn-primary">
              <FiDownload /> Download PDF
            </a>
          )}
        </div>

        <div className="resume-grid">
          <div className="resume-main">
            <div className="resume-section">
              <h2><FiBriefcase /> Experience</h2>
              {experiences.map(exp => (
                <div key={exp.id} className="resume-item">
                  <div className="resume-item-header">
                    <h3>{exp.position}</h3>
                    <span className="resume-date">{formatDate(exp.startDate)} - {exp.isCurrent ? 'Present' : formatDate(exp.endDate)}</span>
                  </div>
                  <h4>{exp.companyName}</h4>
                  <p>{exp.description}</p>
                  {exp.achievements?.length > 0 && (
                    <ul>{exp.achievements.map((a, i) => <li key={i}>{a}</li>)}</ul>
                  )}
                </div>
              ))}
            </div>

            <div className="resume-section">
              <h2><FiBook /> Education</h2>
              {education.map(edu => (
                <div key={edu.id} className="resume-item">
                  <div className="resume-item-header">
                    <h3>{edu.degree}</h3>
                    <span className="resume-date">{formatDate(edu.startDate)} - {edu.isCurrent ? 'Present' : formatDate(edu.endDate)}</span>
                  </div>
                  <h4>{edu.institution}</h4>
                  {edu.grade && <p><strong>Grade:</strong> {edu.grade}</p>}
                  {edu.description && <p>{edu.description}</p>}
                </div>
              ))}
            </div>
          </div>

          <div className="resume-sidebar">
            <div className="resume-section">
              <h2><FiCode /> Skills</h2>
              <div className="resume-skills">
                {skills.map(skill => (
                  <div key={skill.id} className="resume-skill">
                    <div className="resume-skill-header">
                      <span>{skill.name}</span>
                      <span>{skill.proficiency}%</span>
                    </div>
                    <div className="resume-progress">
                      <div className="resume-progress-fill" style={{ width: `${skill.proficiency}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
